import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'widgets/Button';
import { Layout } from 'antd';
const { Footer } = Layout;
import constants from 'constants';
import styles from './index.scss';
import APP_INFO from '../../../../APP_INFO';

const SiteFooter = ({ isMobile }) => {
	useEffect(() => {
		console.info(
			`%cCurrent Build Id: ${APP_INFO.COMMIT_HASH}`,
			'background:blue;color:#fff'
		);
	}, [])
  return (
    <Footer className={styles.root}>
      {!isMobile && (
        <ul className={styles.firstList}>
          <li>
            <div className={styles.listLink}>
              {APP_INFO.NAME} ( {constants.env}, {APP_INFO.VERSION} ) | Build
              Id: {APP_INFO.COMMIT_HASH}
            </div>
          </li>
          <li>
            <Button size="small" type="dashed" style={{ marginLeft: '12px' }}>
              <a
                href="mailto:techsupport@upgrad.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Support
              </a>
            </Button>
          </li>
        </ul>
      )}
      <ul className={styles.secondList}>
        <li>
          <div className={styles.listLink}>All right reserved.</div>
        </li>
        <li>
          <div className={styles.listLink}>
            {APP_INFO.COPYRIGHT}, {APP_INFO.COMPANY}
          </div>
        </li>
      </ul>
    </Footer>
  );
};

SiteFooter.propTypes = {
  isMobile: PropTypes.bool,
};

export default SiteFooter;
